export const CTA_TEXT_GET_STARTED = 'Get started'
export const CTA_TEXT_COMPARE_CARDS = 'Compare cards'
export const CTA_TEXT_COMPARE_LOANS = 'Compare loans'

export const CTA_TEXT_FIND_MY_DEAL = 'Find my deal'
export const CTA_TEXT_COMPARE_INSURANCE = 'Compare insurance'
